import Vue from 'vue';
import { mapState } from 'vuex';
import LogoApp from '@/components/_core/ui/logo';

export default Vue.extend({
  components: {
    LogoApp
  },
  props: {
    title       : String,
    subtitle    : String,
    iconVisible : {
      type    : Boolean,
      default : false
    },
    iconAction: {
      type: Function
    },
    logo: {
      type    : Boolean,
      default : false
    }
  },
  computed: {
    ...mapState({
      headerSettings: (state) => state._core.header
    })
  }
});
